// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"58d216d5","949":"114179f9"}[chunkId] + ".chunk.js";
};